<template>
    <div class="searchList">
        <el-container>
            <el-header>
                <div class="header-nav">
                    <nav-top/>
                </div>
                <div class="search">
                    <div class="searchbar">
                        <div class="tabs">
                <span v-for="(item,index) in tablist" :class="{active:isTab===index}" :key="index"
                      @click.stop="show(index)">{{item.tit}}</span>
                        </div>
                        <div class="ordinarySearch" v-show="!isshow">
                            <div class="select" @mouseenter="enter" @mouseleave="leave">
                                <span>{{showName}}<i class="el-icon-arrow-down"></i></span>
                                <ul v-show="isshowName">
                                    <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                                        {{item.name}}
                                    </li>
                                </ul>
                            </div>
                            <el-input placeholder="请输入要查询的内容" v-model="ordinarySearchData" class="input-with-select"
                                      style="{height: 60px}">
                                <el-button slot="append" @click="sendOrdinarySearchData">搜索</el-button>
                            </el-input>
                        </div>
                        <div class="accurateSearch" v-show="isshow">
                            <div class="box">
                                <div class="left">
                                    <el-input v-model="input1" placeholder="输入检测对象关键字"></el-input>
                                    ---
                                    <el-input v-model="input2" placeholder="输入项目检测关键字"></el-input>
                                    ---
                                    <el-input v-model="input3" placeholder="输入检测标准关键字"></el-input>
                                    <el-button plain @click="sendOrdinarySearchData">搜索</el-button>
                                </div>
                            </div>
                            <div class="select" @mouseenter="enter" @mouseleave="leave">
                                <span>{{showName}} <i class="el-icon-arrow-down"></i></span>
                                <ul v-show="isshowName">
                                    <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                                        {{item.name}}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <img src="../../../static/images/searchlist-banner.jpg" alt="">
                </div>
            </el-header>
            <el-main>
                <template>
                    <el-table
                            v-loading="loading"
                            element-loading-text="数据加载中..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                            :header-cell-style="{background: '#00cccc',color: '#ffffff'}"
                            :data="tableData"
                            stripe
                            style="width: 100%">
                        <el-table-column
                                prop="name"
                                label="检测对象"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="category"
                                label="项目参数"
                                width="180">
                        </el-table-column>
                        <el-table-column
                                prop="standard"
                                label="检测标准">
                        </el-table-column>
                        <el-table-column
                                prop="organization"
                                label="检测单位">
                            <template slot-scope="scope">
                                <a @click="handleRow(scope.$index,scope.row)" v-if="can('/client/*')" style="color: #00cccc;text-decoration: underline">点击查看单位详情</a>
                                <a v-else>请 <span @click="$store.commit('isShow')" style="color: #00cccc;text-decoration: underline" >登录</span>后查看</a>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="instruction"
                                label="说明">
                        </el-table-column>
                        <el-table-column
                                label="有效期">
                          <template slot-scope="scope">
                            <!-- {{ scope.row.period_validity }} -->
                            {{ parseDate(scope.row.period_validity) }}
                          </template>
                        </el-table-column>
                    </el-table>
                </template>
                <template>
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            :page-sizes="[10, 20,30, 40]"
                            :page-size="20"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </template>
                <template>
                    <el-dialog title="单位详情" :visible.sync="dialogTableVisible" width="450px">
                        <h1 style="font-size: 18px;color: #333;margin-bottom: 10px">{{organizationName}}</h1>
                        <div class="organization-content">
                            <div class="address"><span class="left">地址</span> <span class="right">{{address}}</span>
                            </div>
                            <div class="linkName"><span class="left" style="margin-right: 16px">联系人</span><span
                                    class="right">{{linkName}}</span></div>
                            <div class="lanLine"><span class="left">电话</span><span class="right">{{landLine}}</span></div>
                            <div class="mobilePhone"><span class="left">手机</span><span class="right">{{mobilePhone}}</span></div>
                            <div class="email"><span class="left">邮箱</span><span class="right">{{email}}</span></div>
                        </div>

                    </el-dialog>
                </template>
            </el-main>
            <el-footer>
                <div class="footer-info">
                    <span>备案号:蜀ICP备16034344</span>
                </div>
            </el-footer>
        </el-container>
        <div class="content" v-show="$store.state.isLogin">
        </div>
    </div>
</template>

<script>
  import Bar from '../common/searchbar'
  import Http from '../../utils/Http'
  import NavTop from '@/components/common/NavTop'
  import Auth from '@/auth/Auth'
  import { parseDate } from '../../utils/parseDate'

  export default {
    inject: ['reload'],
    props: {
      noUser: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        tableData: [],
        total: 0,
        sizepage: 20,
        page: 1,
        login: false,
        user: {},
        roles: {},
        isshow: 0,
        tablist: [
          {tit: '普通搜索', show: true},
          {tit: '精准搜索', show: false}
        ],
        liList: [
          {name: '检验检测'},
          {name: '计量校准'}
        ],
        showName: '检验检测',
        isshowName: false,
        isTab: 0,
        searchData: '',
        ordinarySearchData: '',
        input1: '',
        input2: '',
        input3: '',
        input: '',
        selectName: '检验检测',
        dialogTableVisible: false,
        organizationName: '',
        address: '',
        linkName: '',
        landLine: '',
        email: '',
        mobilePhone: '',
        loading: true
      }
    },
    methods: {
      // 处理时间
      parseDate,
      JudgeData () {
        var data = JSON.parse(sessionStorage.getItem('store'))
        if (data[0] === 0) {
          this.isTab = data[0]
          this.isshow = data[0]
          this.ordinarySearchData = data[1]
          this.getSearchData(data[1], data[2])
        } else if (data[0] === 1) {
          this.isTab = data[0]
          this.isshow = data[0]
          this.input1 = data[1]
          this.input2 = data[2]
          this.input3 = data[3]
          this.getAccurateData(data[1], data[2], data[3], data[4])
        }
      },
      sendOrdinarySearchData () {
        this.page = 1
        if (this.isTab === 0) {
          let dataArr = [this.isTab, this.ordinarySearchData, this.showName]
          this.$store.commit('addOrdinarySearchData', dataArr)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state.ordinarySearchData))
          this.JudgeData()
        } else if (this.isTab === 1) {
          let dataArr = [this.isTab, this.input1, this.input2, this.input3, this.showName]
          this.$store.commit('addOrdinarySearchData', dataArr)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state.ordinarySearchData))
          this.JudgeData()
        }
      },
      getSearchData (key, type) {
        this.page = 1
        let url
        if (type === '检验检测') {
          url = `/data/api/detection/es/query?page=${this.page}&rows=${this.sizepage}&key=${key}`
        } else if (type === '计量校准') {
          url = `/data/api/metering/es/query?page=${this.page}&rows=${this.sizepage}&key=${key}`
        }
        Http.fetch(
          url,
          {},
          result => {
            if (result.status === 200 && result.data.content.length !== 0) {
              this.tableData = []
              this.total = result.data.totalElements
              if (this.total > 10000) {
                this.total = 10000
              }
              this.tableData = result.data.content
              this.loading = false
            } else {
              this.tableData = []
              this.loading = false
            }
          }
        )
      },
      getAccurateData (name, category, standard, type) {
        this.page = 1
        let url
        if (type === '检验检测') {
          url = `/data/api/detection/es/advanced/query?page=${this.page}&rows=${this.sizepage}&name=${name}&category=${category}&standard=${standard}`
        } else if (type === '计量校准') {
          url = `/data/api/metering/es/advanced/query?page=${this.page}&rows=${this.sizepage}&name=${name}&category=${category}&standard=${standard}`
        }
        Http.fetch(
          url,
          {},
          result => {
            if (result.status === 200 && result.data.content.length !== 0) {
              this.tableData = []
              this.total = result.data.totalElements
              if (this.total > 10000) {
                this.total = 10000
              }
              this.tableData = result.data.content
              this.loading = false
            } else {
              this.tableData = []
              this.loading = false
            }
          }
        )
      },
      getSearchData1 (key, type) {
        let url
        if (type === '检验检测') {
          url = `/data/api/detection/es/query?page=${this.page}&rows=${this.sizepage}&key=${key}`
        } else if (type === '计量校准') {
          url = `/data/api/metering/es/query?page=${this.page}&rows=${this.sizepage}&key=${key}`
        }
        Http.fetch(
          url,
          {},
          result => {
            if (result.status === 200 && result.data.content.length !== 0) {
              this.tableData = []
              this.total = result.data.totalElements
              if (this.total > 10000) {
                this.total = 10000
              }
              this.tableData = result.data.content
              this.loading = false
            } else {
              this.tableData = []
              this.loading = false
            }
          }
        )
      },
      getAccurateData2 (name, category, standard, type) {
        let url
        if (type === '检验检测') {
          url = `/data/api/detection/es/advanced/query?page=${this.page}&rows=${this.sizepage}&name=${name}&category=${category}&standard=${standard}`
        } else if (type === '计量校准') {
          url = `/data/api/metering/es/advanced/query?page=${this.page}&rows=${this.sizepage}&name=${name}&category=${category}&standard=${standard}`
        }
        Http.fetch(
          url,
          {},
          result => {
            if (result.status === 200 && result.data.content.length !== 0) {
              this.tableData = []
              this.total = result.data.totalElements
              if (this.total > 10000) {
                this.total = 10000
              }
              this.tableData = result.data.content
              this.loading = false
            } else {
              this.tableData = []
              this.loading = false
            }
          }
        )
      },
      handleSizeChange (size) {
        var data = JSON.parse(sessionStorage.getItem('store'))
        this.sizepage = size
        if (data[0] === 0) {
          this.getSearchData1(data[1], data[2])
        } else if (data[0] === 1) {
          this.getAccurateData2(data[1], data[2], data[3], data[4])
        }
      },
      handleCurrentChange (page) {
        var data = JSON.parse(sessionStorage.getItem('store'))
        this.page = page
        if (data[0] === 0) {
          this.getSearchData1(data[1], data[2])
        } else if (this.isTab === 1) {
          this.getAccurateData2(data[1], data[2], data[3], data[4])
        }
      },
      getHeight () {
        this.height = window.innerHeight
      },
      enter () {
        this.isshowName = true
      },
      leave () {
        this.isshowName = false
      },
      show (index) {
        this.isTab = index
        this.isshow = index
      },
      can (permission) {
        return Auth.can(permission)
      },
      handleRow (index, row) {
        this.dialogTableVisible = !this.dialogTableVisible
        this.address = row.organization.address
        this.organizationName = row.organization.name
        this.linkName = row.organization.linkName
        this.landLine = row.organization.landLine
        this.email = row.organization.email
        this.mobilePhone = row.organization.mobilePhone
      }
    },
    mounted () {
      this.JudgeData()
    },
    created () {
    },
    components: {
      Bar,
      NavTop
    }
  }
</script>

<style scoped>
    .searchList .el-container .el-header {
        height: 100% !important;
        padding: 0 !important;
    }

    .searchList .el-container .top-nav {
        background: #021221;
    }

    .searchList .el-container .search {
        display: block;
    }

    .searchList .el-container .top-nav img {
        width: 100%;
        height: 190px;
    }

    .el-container .top-nav .top-nav-center {
        width: 1200px;
        margin: 0 auto;
        color: #fff;
        height: 60px;
        line-height: 60px;
    }

    .top-nav .top-nav-center h1 {
        display: inline-block;
    }

    .top-nav .top-nav-center .top-info {
        display: inline-block;
        float: right;
    }

    .top-nav-center .top-info a {
        color: #fff;
        padding: 0 20px;
    }

    .el-container .el-main {
        margin: 40px auto;
        width: 1200px;
        box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05);
        padding: 0;
    }

    .searchList .el-container .el-footer {
        height: 40px !important;
        background: #021221;
        width: 100%;
    }

    .el-container .el-footer .footer-info {
        width: 1200px;
        margin: 0 auto;
        color: #fff;
        text-align: center;
        line-height: 40px;
    }

    .clearfix:after {
        content: ".";
        clear: both;
        height: 0;
        overflow: hidden;
        visibility: hidden;
        display: block;
    }

    .clearfix {
        zoom: 1;
    }

    .el-header .search {
        position: relative;
    }

    .el-header .search .searchbar {
        position: absolute;
        top: 0;
        left: 25%;
    }

    .search .searchbar .tabs {
        height: 80px;
        line-height: 80px;
        text-align: center;
    }

    .search .searchbar .tabs span {
        padding: 10px 15px;
        border-radius: 4px;
        color: #fff;
    }

    .search .accurateSearch >>> .el-input {
        width: 230px;
    }

    .searchList .accurateSearch >>> .el-input .el-input__inner {
        /*border: 1px solid #fff!important;*/
        border: none;
        height: 58px;
    }

    .search .accurateSearch .box .left {
        background: #fff;
        border-radius: 5px;
        border: none;
    }

    .search .accurateSearch .box .left .el-button {
        border: 1px solid #00cccc;
        height: 60px;
        width: 90px;
        font-size: 18px;
        background: #00cccc;
        text-align: center;
        padding: 0;
        color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .searchList .ordinarySearch /deep/ .el-input .el-input__inner {
        width: 730px;
        height: 60px;
    }

    .searchList .accurateSearch >>> .el-input .el-input__inner {
        /*border: 1px solid #fff!important;*/
        border: none;
        height: 58px;
    }

    .search .accurateSearch .box .left .el-button {
        border: 1px solid #00cccc;
        height: 60px;
        width: 90px;
        font-size: 18px;
        background: #00cccc;
        text-align: center;
        padding: 0;
        color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .search .ordinarySearch .el-input .el-button {
        border: 1px solid #00cccc;
        height: 60px;
        width: 90px;
        font-size: 18px;
        background: #00cccc;
        text-align: center;
        padding: 0 1px 0 0;
        color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .searchList .ordinarySearch {
        position: relative;
    }

    .searchList .accurateSearch {
        position: relative;
    }

    .searchList >>> .select {
        position: absolute;
        top: 25px;
        left: -80px;
        color: #fff;
    }

    .searchList >>> .select ul li {
        padding: 5px 0;
        cursor: pointer;
    }

    .active {
        border: 1px solid #00cccc !important;
        background: #00cccc;
    }

    .organization-content div {
        padding: 10px 0;
    }

    .organization-content .left {
        font-size: 16px;
        color: #999;
        margin-right: 30px;
    }

    .organization-content .right {
        font-size: 16px;
        color: #333;
    }

    a {
        cursor: pointer
    }

    .searchList >>>.el-input-group__append, .el-input-group__prepend {
        border: 1px solid #00cccc;
    }
</style>



// WEBPACK FOOTER //
// src/components/searchlist/searchlist.vue